import { useQueryClient } from '@tanstack/react-query'
import { ComponentType, useEffect } from 'react'

type QueryDefaultOptions = {
  queries?: {
    retry?: boolean | number
    refetchOnMount?: boolean
    refetchOnWindowFocus?: boolean
    refetchOnReconnect?: boolean
    staleTime?: number
    gcTime?: number
    [key: string]: unknown
  }
  mutations?: {
    retry?: boolean | number
    [key: string]: unknown
  }
}

export function withQueryClient<P extends object>(
  WrappedComponent: ComponentType<P>,
  queryDefaultOptions: QueryDefaultOptions
) {
  const WithQueryClientComponent = (props: P) => {
    const queryClient = useQueryClient()

    useEffect(() => {
      queryClient.setDefaultOptions(queryDefaultOptions)
    }, [queryClient])

    return <WrappedComponent {...props} />
  }

  WithQueryClientComponent.displayName = `withQueryClient(${WrappedComponent.displayName || WrappedComponent.name})`

  return WithQueryClientComponent
}
